import React from 'react';
import CountryFlag from '../common/CountryFlag';
import CountryEditor from '../common/editors/CountryEditor';
import { IconButton } from '../common/IconButton';
import ModelTypeSelector from './ModelTypeSelector';
import ModelSubtypeSelector from './ModelSubtypeSelector';
import ModelPowertrainSelector from './ModelPowertrainSelector';
import ModelIdSelector from './ModelIdSelector';
import _ from 'lodash';

function YearInput({ value, onChange }) {
  let isValid = !value || (_.isNumber(value) && value >= 1979 && value <= 2026);
  return <input type='number'
    style={{ width: '100px' }}
    className={`form-control form-control-sm text-info ${isValid ? 'text-info' : 'text-danger bg-light-danger'}`}
    defaultValue={value}
    placeholder='YYYY'
    onChange={v => onChange(parseInt(v.target.value))}
  />
}

export function ModelTypeByCountryEditor({ value, onChange }) {
  let countries = Object.keys(value || {}).sort();

  return <div>
    {countries.map(country => {
      let membersSelector = null, parentSelector = null;
      let { type, members, parent, subtype, powertrain, relatedModels, rename } = value[country];

      const onPropChange = (prop, newValue) => {
        let newCountryValue = { ...value[country] };
        _.set(newCountryValue, prop, newValue);
        if(prop === 'type') {
          if(newValue !== 'family') {
            delete newCountryValue.members;
          }
          if(newValue !== 'submodel') {
            delete newCountryValue.parent;
            delete newCountryValue.subtype;
          }
        }
        return onChange({ ...value, [country]: newCountryValue });
      };

      if (type === 'family' || members?.length) {
        membersSelector = <div className='zoom-90 d-flex align-items-center flex-grow-1'>
          Members: <ModelIdSelector value={members} onChange={v => onPropChange('members', v)} multi={true} className='flex-grow-1 ml-2' />
        </div>
      }

      if (type === 'submodel' || parent) {
        parentSelector = <div className='zoom-90 d-flex align-items-center ml-2'>
          Parent: <ModelIdSelector value={parent} onChange={v => onPropChange('parent', v)} className='ml-2' />
        </div>
      }

      return <div key={country} className='border rounded p-1 my-1 bg-light'>
        <div className={'d-flex align-items-center'}>
          <span style={{ width: '230px' }} className='zoom-75'>
            <CountryEditor value={country} onChange={newKey => {
              if (newKey !== country) {
                const newValue = { ...value };
                if (newKey) {
                  newValue[newKey] = value[country];
                  delete newValue[country];
                  onChange(newValue);
                }
              }
            }} />
          </span>

          <ModelTypeSelector className={'ml-2 align-self-center'} value={type} onChange={v => onPropChange('type', v)} />

          <ModelSubtypeSelector type={type} className={'ml-2 align-self-center'} value={subtype} onChange={v => onPropChange('subtype', v)} />

          {membersSelector}

          {parentSelector}
        </div>

        <div className={'zoom-90 d-flex align-items-center mt-2'}>
          Powertrain: <ModelPowertrainSelector className={'ml-2'} value={powertrain} onChange={v => onPropChange('powertrain', v)} />
        </div>

        <div className={'align-items-start pt-2 zoom-75 mt-2'} style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridColumnGap: '10px'}}>
          <div className='align-items-center'>
            Related models: <ModelIdSelector value={relatedModels || []} multi onChange={v => onPropChange('relatedModels', v)} className='mt-1' />
          </div>

          <div className={'border rounded p-1 ' + (rename?.renamedFrom ? 'bg-light-primary' : 'bg-light-secondary translucent')}>
            Renamed from: <ModelIdSelector value={rename?.renamedFrom} onChange={v => onPropChange('rename.renamedFrom', v)} className='d-inline-block' />
            <div className={'d-flex align-items-center'}>
              in year: &nbsp;<YearInput value={rename?.fromYear} onChange={v => onPropChange('rename.fromYear', v)} />
            </div>
          </div>

          <div className={'border rounded p-1 ' + (rename?.renamedTo ? 'bg-light-primary' : 'bg-light-secondary translucent')}>
            Renamed to: <ModelIdSelector value={rename?.renamedTo} onChange={v => onPropChange('rename.renamedTo', v)} className='d-inline-block' />
            <div className={'d-flex align-items-center'}>
              since year: &nbsp;<YearInput value={rename?.toYear} onChange={v => onPropChange('rename.toYear', v)} />
            </div>
          </div>

        </div>
      </div>
    })}
    <div className={'text-center'}>
      <IconButton icon={'add'} onClick={() => onChange({ ...value, 'otro': { type: 'model' } })}>Add country type</IconButton>
    </div>
  </div>;
}
